export const WorkData = [
    {
      company: "Express Store",
      designation: "Software Engineer intern",
      dateJoining: "07/2021",
      dateEnd: "12/2021",
      companyLogo: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/1200px-Google_%22G%22_Logo.svg.png",
      work: "Django Framework was used in developing web applications to implement the model view control architecture. Collaborated with PMs, agile engineering team and conducted regular system deployments to QA and Production.",
    },
    {
      company: "Dhio Research",
      designation: "Summer intern",
      dateJoining: "05/2020",
      dateEnd: "06/2020",
      companyLogo: "https://media.glassdoor.com/sqll/462381/dhio-research-and-engineering-squarelogo-1464356842692.png",
      work: "Carried out the experiment on ANSYS Workbench under different Modal frequencies to find the Total Deformation and equivalent stress.: We can find the safest frequencies under given pressure conditions for the pump casing to operate without experiencing failure.",
    },
  ];